export default __webpack_public_path__ + "static/media/esLogo.5c4f7781.png";